import { render, staticRenderFns } from "./SizesSelection.vue?vue&type=template&id=67651ca5&scoped=true&"
import script from "./SizesSelection.vue?vue&type=script&lang=js&"
export * from "./SizesSelection.vue?vue&type=script&lang=js&"
import style0 from "./SizesSelection.vue?vue&type=style&index=0&id=67651ca5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67651ca5",
  null
  
)

export default component.exports